import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';

// Soft UI Context Provider
import { SoftUIControllerProvider } from 'context';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <SoftUIControllerProvider>
            <App />
        </SoftUIControllerProvider>
    </BrowserRouter>
);
